"use strict";

exports.__esModule = true;
exports.routeHooks = routeHooks;

var _apmRumCore = require("@elastic/apm-rum-core");

function routeHooks(router, apm) {
  var transaction;
  router.beforeEach(function (to, from, next) {
    var matched = to.matched || [];
    var path = to.path;

    if (matched.length > 0) {
      path = matched[matched.length - 1].path || path;
    }

    transaction = apm.startTransaction(path, 'route-change', {
      managed: true,
      canReuse: true
    });
    next();
  });
  router.afterEach(function () {
    (0, _apmRumCore.afterFrame)(function () {
      return transaction && transaction.detectFinish();
    });
  });
  router.onError(function () {
    transaction && transaction.end();
  });
}